export default [
    {
        name: '<code>$taginput-height</code>',
        default: '<code>1.7em</code>'
    }
]



// WEBPACK FOOTER //
// ./docs/pages/components/taginput/variables/taginput.js